import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  Avatar,
} from "@mui/material";
import DescriptionIcon from "@mui/icons-material/Description";
import PeopleIcon from "@mui/icons-material/People";
import BusinessIcon from "@mui/icons-material/Business";
import PhoneCallbackIcon from "@mui/icons-material/PhoneCallback";
import { useEffect, useState } from "react";
import useAxiosRequests from "../../hooks/useAxiosRequest";
import ExternalRoutes from "../../config/ExternalRoutes";
import { useNavigate } from "react-router-dom";

const defaultStats = [
  {
    label: "Documents",
    value: 0,
    icon: <DescriptionIcon />,
    color: "#1976d2",
    route: "/contab-admin/document",
  },
  {
    label: "Utilisateurs",
    value: 0,
    icon: <PeopleIcon />,
    color: "#388e3c",
    route: "/contab-admin/user",
  },
  {
    label: "Sociétés",
    value: 0,
    icon: <BusinessIcon />,
    color: "#f57c00",
    route: "/contab-admin/society",
  },
  {
    label: "Se faire rappeler",
    value: 0,
    icon: <PhoneCallbackIcon />,
    color: "#9c27b0",
    route: "/contab-admin/call-remember",
  },
];

export const AdminHome = () => {
  const [countUser, setCountUser] = useState(null);
  const [countDocuments, setCountDocuments] = useState(null);
  const [countSocieties, setCountSocieties] = useState(null);
  const [countCall, setCountCall] = useState(null);
  const [dynamicStats, setDynamicStats] = useState(defaultStats);
  const [counters, setCounters] = useState([0, 0, 0, 0]);

  const { sendRequest } = useAxiosRequests();
  const navigate = useNavigate();

  const fetchUsers = async () => {
    try {
      const response = await sendRequest({
        method: "GET",
        url: ExternalRoutes.users.list,
      });

      if (response) {
        setCountUser(response.totalItems);
      }
    } catch (error) {
    }
  };

  const fetchDataDoc = async () => {
    try {
      const response = await sendRequest({
        method: "GET",
        url: ExternalRoutes.document.conDocuments,
      });

      if (response) {
        setCountDocuments(response.totalItems);
      } 
    } catch (error) {
    }
  };

  const fetchDataSociety = async () => {
    try {
      const response = await sendRequest({
        method: "GET",
        url: ExternalRoutes.society.list,
      });

      if (response) {
        setCountSocieties(response.totalItems);
      }
    } catch (error) {
    }
  };

  const fetchDataCall = async () => {
    try {
      const response = await sendRequest({
        method: "GET",
        url: ExternalRoutes.callRemember.list,
      });

      if (response && Array.isArray(response.member)) {
        const uncalled = response.member.filter(
          (item) => item.callRmbIsCalled === false
        );
        setCountCall(uncalled.length);
      } 
    } catch (error) {
    }
  };

  useEffect(() => {
    fetchUsers();
    fetchDataDoc();
    fetchDataSociety();
    fetchDataCall();
  }, []);

  useEffect(() => {
    if (
      countUser !== null &&
      countDocuments !== null &&
      countSocieties !== null &&
      countCall !== null
    ) {
      setDynamicStats([
        {
          ...defaultStats[0],
          value: countDocuments,
        },
        {
          ...defaultStats[1],
          value: countUser,
        },
        {
          ...defaultStats[2],
          value: countSocieties,
        },
        {
          ...defaultStats[3],
          value: countCall,
        },
      ]);
    }
  }, [countUser, countDocuments, countSocieties, countCall]);

  useEffect(() => {
    const intervals = [];
    dynamicStats.forEach((stat, index) => {
      let count = 0;
      const increment = Math.ceil(stat.value / 30);

      const interval = setInterval(() => {
        count += increment;
        if (count >= stat.value) {
          count = stat.value;
          clearInterval(interval);
        }

        setCounters((prev) => {
          const newCounters = [...prev];
          newCounters[index] = count;
          return newCounters;
        });
      }, 30);

      intervals.push(interval);
    });

    return () => {
      intervals.forEach(clearInterval);
    };
  }, [dynamicStats]);

  const handleClick = (route) => {
    navigate(route);
  };

  return (
    <Box p={4} width="100%" maxWidth="100%">
      <Typography variant="h4" gutterBottom>
        Admin Dashboard
      </Typography>
      <Typography variant="body1" gutterBottom>
        Bienvenue
      </Typography>

      <Grid container spacing={6} mt={4}>
        {dynamicStats.map((item, index) => (
          <Grid  size={{ xs: 12, sm: 6 ,md:3}}  key={index}>
            <Card
              sx={{
                display: "flex",
                alignItems: "center",
                p: 2,
                boxShadow: 4,
                borderRadius: 3,
                transition: "transform 0.3s",
                height: "100%",
                cursor: "pointer",
                "&:hover": {
                  transform: "scale(1.03)",
                },
              }}
              onClick={() => handleClick(item.route)}
            >
              <Avatar
                sx={{
                  bgcolor: item.color,
                  mr: 2,
                  width: 56,
                  height: 56,
                }}
              >
                {item.icon}
              </Avatar>
              <CardContent sx={{ p: 0 }}>
                <Typography variant="h6" color="text.secondary">
                  {item.label}
                </Typography>
                <Typography variant="h4" fontWeight={600}>
                  {counters[index]}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
